import { Component, Property } from '@wonderlandengine/api';
import { vec3 } from 'gl-matrix';

/**
 * Extended WASD controls with vertical movement (Q/E for up/down)
 */
export class ExtendedWasdControls extends Component {
    static TypeName = 'extended-wasd-controls';
    static Properties = {
        speed: Property.float(0.1),
        verticalSpeed: Property.float(0.1),
        headObject: Property.object(),
        lockY: Property.bool(false)
    };
    
    init() {
        // Movement state
        this.forward = false;
        this.backward = false;
        this.left = false;
        this.right = false;
        this.up = false;
        this.down = false;
        
        // Temp vectors
        this.direction = new Float32Array(3);
        this.tempTransform = new Float32Array(8);
    }
    
    start() {
        this.headObject = this.headObject || this.object;
        console.log('[ExtendedWasdControls] Started with vertical movement (Q/E for up/down)');
    }
    
    onActivate() {
        window.addEventListener('keydown', this.onKeyDown);
        window.addEventListener('keyup', this.onKeyUp);
    }
    
    onDeactivate() {
        window.removeEventListener('keydown', this.onKeyDown);
        window.removeEventListener('keyup', this.onKeyUp);
    }
    
    onKeyDown = (e) => {
        this.handleKey(e, true);
    }
    
    onKeyUp = (e) => {
        this.handleKey(e, false);
    }
    
    handleKey(e, pressed) {
        switch(e.code) {
            case 'KeyW':
            case 'ArrowUp':
                this.forward = pressed;
                break;
            case 'KeyS':
            case 'ArrowDown':
                this.backward = pressed;
                break;
            case 'KeyA':
            case 'ArrowLeft':
                this.left = pressed;
                break;
            case 'KeyD':
            case 'ArrowRight':
                this.right = pressed;
                break;
            case 'KeyQ':
                this.up = pressed;
                break;
            case 'KeyE':
                this.down = pressed;
                break;
        }
    }
    
    update(dt) {
        vec3.zero(this.direction);
        
        // Forward/backward
        if (this.forward) this.direction[2] -= 1.0;
        if (this.backward) this.direction[2] += 1.0;
        
        // Left/right
        if (this.left) this.direction[0] -= 1.0;
        if (this.right) this.direction[0] += 1.0;
        
        // Only process if there's horizontal movement
        if (this.direction[0] !== 0 || this.direction[2] !== 0) {
            vec3.normalize(this.direction, this.direction);
            vec3.scale(this.direction, this.direction, this.speed);
            
            // Transform by head rotation
            vec3.transformQuat(
                this.direction, 
                this.direction, 
                this.headObject.getTransformWorld(this.tempTransform)
            );
            
            // Lock Y if enabled
            if (this.lockY) {
                this.direction[1] = 0;
                vec3.normalize(this.direction, this.direction);
                vec3.scale(this.direction, this.direction, this.speed);
            }
            
            this.object.translateLocal(this.direction);
        }
        
        // Vertical movement (not affected by head rotation)
        if (!this.lockY) {
            if (this.up) {
                this.object.translateLocal([0, this.verticalSpeed, 0]);
            }
            if (this.down) {
                this.object.translateLocal([0, -this.verticalSpeed, 0]);
            }
        }
    }
}